export const JobPositionVI = {
    "jobPosition": {
        "title": {
            "header": " Danh sách vị trí",
            "add": "Tạo mới vị trí",
            "update":"Cập nhật vị trí"
        },
        "columns": {
            "id": "ID",
            "name": "Tên",
            "order": "Thứ tự",
            "jobTitleName": "Chức vụ",
            "salaryMax": "Lương tối đa",
            "salaryMin": "Lương tối thiểu",
        }
    }
}